const API_BASE = "https://kcrm.gpoptima.info/apis/api_meetings.php";

export async function apiFetch(options = {}) {
    try {
        const response = await fetch(`${API_BASE}`, {
            method: options.method || "GET",
            headers: {
                "Content-Type": "application/json",
                ...(options.headers || {}),
            },
            body: options.body ? JSON.stringify(options.body) : null,
        });

        if (!response.ok) {
            throw new Error(`Error en la petición: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error en apiFetch:", error);
        throw error;
    }
}